import React, { useRef, useState, useEffect, useCallback } from "react";
import Webcam from "react-webcam";
import "./Camera.scss";
import { Link, useNavigate } from "react-router-dom";
import { imageSet } from "./App";
import ShutterSoundMP3 from './audio/shutterSound.mp3';

const videoConstraints = {
    width: 405,
    height: 268,
    facingMode: "user"
};

const Camera = () => {
    const navigate = useNavigate();
    const webcamRef = useRef(null);
    const [url, setUrl] = useState(null);
    const [number, setNumber] = useState(0);
    const [timer, setTimer] = useState(3);
    const [isCounting, setIsCounting] = useState(true);
    const shutterSound = useRef(new Audio(ShutterSoundMP3));

    useEffect(() => {
        for(let i=0; i<8; i++) imageSet[i] = null;
    }, []);

    const capturePhoto = useCallback(() => {
        if (number >= 8) return;

        const imageTmp = webcamRef.current.getScreenshot({ width: 405, height: 268 });
        imageSet[number] = imageTmp;
        setUrl(imageTmp);
        
        shutterSound.current.play();
        
        const nextNumber = number + 1;
        setNumber(nextNumber);

        if (nextNumber >= 8) {
            setIsCounting(false);
            setTimeout(() => {
                navigate("/Select");
            }, 1000);
        } else {
            setTimer(3);
        }
    }, [webcamRef, number, navigate]);

    useEffect(() => {
        let interval = null;
        if (isCounting && number < 8) {
            interval = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        capturePhoto();
                        return 3;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isCounting, number, capturePhoto]);

    const onUserMedia = (e) => {};

    const keyDown = useCallback((e) => {
        if (e.key === "PageDown" || e.key === " ") {
            e.preventDefault();
            capturePhoto();
        }
    }, [capturePhoto]);

    useEffect(() => {
        window.addEventListener("keydown", keyDown);
        return () => window.removeEventListener("keydown", keyDown);
    }, [keyDown]);

    return (
        <div className="CameraDiv">
            <div className="mainContent">
                <Webcam className="Webcam"
                    ref={webcamRef}
                    audio={false}
                    screenshotFormat="image/jpeg"
                    forceScreenshotSourceSize={true}
                    videoConstraints={videoConstraints}
                    onUserMedia={onUserMedia}
                    screenshotQuality={1}
                    mirrored={true}
                />

                <div className="sidePanel">
                    <div className="cameraUI">
                        <div className="timerDisplay">
                            {isCounting && number < 8 ? timer : "Done!"}
                        </div>
                        <h1 className="counter">{number}/8</h1>
                        <button className="shutter" onClick={capturePhoto}></button>
                    </div>

                    {url && (
                        <div className="prevCameraImg">
                            <div className="prevCameraImgCaption">마지막 촬영 사진</div>
                            <img src={url} className="prevCameraImgSC" alt="Screenshot" />
                        </div>
                    )}
                </div>
            </div>

            <div className="containerMent">
                <div className="guideMent">3초마다 자동으로 촬영됩니다!<br></br>셔터 버튼이나 리모컨(스페이스바)으로 직접 찍을 수도 있어요!</div>
            </div>
        </div>
    );
};

export default Camera;
